// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useContext, useState } from "react";
import "./login.scss";
import { useNavigate, useOutletContext } from "react-router-dom";

import { login as loginAPI } from "../../_api/auth.js";

import { OutletContextType, requestType } from "../../types/GlobalType";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";
import user_api from "../../apiCaller/user.Caller";
import LoaderLogin from "../../component/loader/LoaderLogin.tsx";
import { useAuth } from "../../_api/auth.js";
import { useMutation } from "@tanstack/react-query";
import { log } from "console";
import { duration } from "moment";
import Notification from "../../component/_elements/Notification.tsx";
// import LOGO from "../../assets/images";
const Log: React.FC = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { login } = useAuth();

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: loginAPI,
    onSuccess: (data) => {
      console.log(data);
      login(data.token, data.data); // store token in context + localStorage
      if (data.token) {
        // Redirect to dashboard or another page
        toast.success("Connexion réussie!", {
          duration: 4000,
          position: "bottom-right",
          style: { background: "green", color: "#fff" },
        });
        navigate("/", { replace: true });
        window.location.href = "/";
      } else
        toast.error(data.message || "Login failed. Please try again.", {
          duration: 4000,
          position: "bottom-right",
          style: {
            background: "red",
            color: "#fff",
            padding: "10px",
            fontSize: "14px",
            borderRadius: "5px",
          },
        });
    },

    onError: (error) => {
      console.log(error);
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const credentials = {
      email,
      password,
    };

    if (!credentials.email || !credentials.password) {
      toast.error("Veuillez remplir tous les champs.");
      return;
    }

    mutation.mutate(credentials);
  };

  return (
    <>
      <LoaderLogin isLoading={mutation.isPending} />
      <div className="min-h-screen bg-gradient-to-br from-blue-500 via-zinc-200 to-gray-50 flex items-center justify-center p-4 relative overflow-hidden">
        {/* Éléments décoratifs en arrière-plan */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 opacity-10">
            <i className="fas fa-graduation-cap text-white text-8xl"></i>
          </div>
          <div className="absolute bottom-32 right-10 opacity-10 animate-pulse-slow">
            <i className="fas fa-book-open text-blue-400 text-6xl"></i>
          </div>
          <div className="absolute bottom-64 right-64 opacity-10 animate-spin">
            <i className="fas fa-clock text-blue-400 text-6xl"></i>
          </div>
          <div className="absolute top-1/3 right-20 opacity-10">
            <i className="fas fa-school text-blue-400 text-9xl"></i>
          </div>
          <div className="absolute bottom-20 left-20 opacity-15 animate-spin-slow">
            <i className="fas fa-chalkboard-teacher text-blue-400 text-5xl"></i>
          </div>
          {/* <div className="absolute bottom-15 left-5 opacity-15">
          <i className="fas fa-chalkboard-teacher text-blue-400 text-8xl"></i>
        </div> */}
        </div>
        {/* Conteneur principal */}
        <div className="w-full max-w-md relative z-10">
          {/* Logo et branding */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500 rounded-full mb-4">
              <img src="/images/chiksoft.png" width={42} alt="Logo" />
              {/* <i className="fas fa-graduation-cap text-white text-2xl"></i> */}
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Chiksoft</h1>
            <p className="text-gray-600 text-sm">
              Système de gestion scolaire moderne
            </p>
          </div>
          {/* Carte de connexion */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            {/* Titre */}
            <div className="text-center mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                Connexion
              </h2>
              <p className="text-gray-600 text-sm">
                Accédez à votre espace de gestion scolaire
              </p>
            </div>
            {/* Formulaire */}
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Champ email */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="fas fa-user text-gray-400 text-sm"></i>
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm bg-white"
                  placeholder="Email ou identifiant"
                />
              </div>
              {/* Champ mot de passe */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="fas fa-lock text-gray-400 text-sm"></i>
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm bg-white"
                  placeholder="Mot de passe"
                  required
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                >
                  <i
                    className={`fas ${
                      showPassword ? "fa-eye-slash" : "fa-eye"
                    } text-gray-400 text-sm hover:text-gray-600 transition-colors`}
                  ></i>
                </button>
              </div>
              {/* Options */}
              <div className="flex items-center justify-between">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <span className="ml-2 text-sm text-gray-600">
                    Se souvenir de moi
                  </span>
                </label>
                <a
                  href="#"
                  className="text-sm text-blue-500 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Mot de passe oublié ?
                </a>
              </div>
              {/* Bouton de connexion */}
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 transition-all duration-200 !rounded-button whitespace-nowrap cursor-pointer"
              >
                Se connecter
              </button>
            </form>
          </div>
          {/* Pied de page */}
          <div className="mt-8 text-center text-gray-600">
            {/* <div className="flex justify-center space-x-6 mb-4 text-sm">
            <a
              href="#"
              className="hover:text-gray-800 transition-colors cursor-pointer"
            >
              Mentions légales
            </a>
            <a
              href="#"
              className="hover:text-gray-800 transition-colors cursor-pointer"
            >
              Confidentialité
            </a>
            <a
              href="#"
              className="hover:text-gray-800 transition-colors cursor-pointer"
            >
              Support
            </a>
          </div> */}
            <p className="text-xs text-gray-500">
              © 2025 Ehula Technologies. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Log;
